import React from "react";

import { isString } from "lodash-es";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

import { Input } from "src/design-system/Input";
import { Tooltip } from "src/design-system/Tooltip";
import { useIsFieldHighlighted } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";
import { getEnumError } from "src/schema/enumUtils";
import { PropertyUI } from "src/schema/schemaMappingUtils";
import { useHighlightedScrollIntoView } from "src/utils/useHighlightedScrollIntoview";

export const SchemaEnumInput: React.FC<{
  disabled: boolean;
  errorStatus?: Merge<FieldError, FieldErrorsImpl<PropertyUI>>;
  formProps: UseFormRegisterReturn;
  searchHighlightKey?: string;
}> = ({ errorStatus, disabled, formProps, searchHighlightKey }) => {
  const hasError = errorStatus !== undefined;
  const enumError = isString(errorStatus?.type)
    ? getEnumError(errorStatus.type)
    : null;

  const isHighlighted = useIsFieldHighlighted(searchHighlightKey);
  const [highlightRef] = useHighlightedScrollIntoView(isHighlighted);

  return (
    <Tooltip
      body={enumError?.description ?? ""}
      disabled={!hasError}
      placement="top"
      title={enumError?.title}
      asChild
    >
      <div ref={highlightRef} className="grow">
        <Input
          dataLoc="schema-enum-value"
          disabled={disabled}
          error={hasError}
          highlighted={isHighlighted}
          variant="monospaced"
          {...formProps}
        />
      </div>
    </Tooltip>
  );
};
